module.exports = __webpack_public_path__ + "img/robot-2.bb88bcbe.png";